//Dafault Material;
import { CommonModule, registerLocaleData } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { BaseUrlPipe, CepPipe, CpfPipe, EmptyPlaceholderPipe, FilterPipe } from "./pipes";
import { CallbackPipe } from "./pipes/callback.pipe";
import { CdkTreeModule } from '@angular/cdk/tree';
import { HammerModule } from '@angular/platform-browser';
import { AppMaterialModule } from "./material/app-material.module";

// Third Plugins;
import { TooltipModule, NgxChartsModule } from '@swimlane/ngx-charts';
import { NgChartsModule } from 'ng2-charts';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { NgxCurrencyModule } from 'ngx-currency';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CdkTableModule } from '@angular/cdk/table';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { DynamicModule } from 'ng-dynamic-component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomSnackbarComponent } from "./components";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { SidebarComponent } from "../@layout/sidebar/sidebar.component";
import { MenuPanelComponent } from "../@layout/menu-panel/menu-panel.component";
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from "ngx-mask";
import { NGX_MAT_DATE_FORMATS, NgxMatDateFormats, NgxMatDatetimePickerModule, NgxMatNativeDateModule, NgxMatTimepickerModule } from "@angular-material-components/datetime-picker";
import { ToastrModule } from "ngx-toastr";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";

//Date and language;
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { PtBrPaginatorIntl } from "../@shared/helpers/pt-br-paginator-intl";
import ptBR from "@angular/common/locales/pt";
import { NgxMatMomentAdapter, NgxMatMomentModule } from "@angular-material-components/moment-adapter";
import { AgGridAngular, AgGridModule } from "ag-grid-angular";

registerLocaleData(ptBR, "pt-BR");
export const MY_FORMATS = {
  parse: {
    dateInput: "DD/MM/YYYY",
  },
  display: {
    dateInput: "DD/MM/YYYY",
    monthYearLabel: "YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "YYYY",
  },
};

const CUSTOM_DATE_FORMATS: NgxMatDateFormats = {
  parse: {
    dateInput: 'DD/MM/YYYY HH:mm:ss',
  },
  display: {
    dateInput: 'DD/MM/YYYY HH:mm:ss',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@NgModule({
  imports: [
    RouterModule,
    AppMaterialModule,
    CdkTreeModule,
    NgChartsModule,
    CollapseModule.forRoot(),
    CommonModule,
    DragDropModule,
    HammerModule,
    NgxChartsModule,
    NgxMaskDirective, NgxMaskPipe,
    TooltipModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    CdkTableModule,
    ProgressbarModule.forRoot(),
    DynamicModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule,
    ToastrModule.forRoot({
      maxOpened: 5,
      preventDuplicates: true
    }),
    NgxMatSelectSearchModule,
    NgxMatMomentModule,
    AgGridAngular,
    AgGridModule
  ],
  declarations: [
    SidebarComponent,
    MenuPanelComponent,
    BaseUrlPipe,
    CepPipe,
    CpfPipe,
    EmptyPlaceholderPipe,
    FilterPipe,
    CallbackPipe,
    CustomSnackbarComponent
  ],
  exports: [
    AppMaterialModule,
    RouterModule,
    CdkTreeModule,
    NgChartsModule,
    CollapseModule,
    CommonModule,
    DragDropModule,
    HammerModule,
    NgxChartsModule,
    NgxMaskDirective, 
    NgxMaskPipe,
    TooltipModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    CdkTableModule,
    ProgressbarModule,
    DynamicModule,
    SidebarComponent,
    MenuPanelComponent,
    BaseUrlPipe,
    CepPipe,
    CpfPipe,
    EmptyPlaceholderPipe,
    FilterPipe,
    CallbackPipe,
    CustomSnackbarComponent,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule,
    NgxMatSelectSearchModule,
    AgGridAngular,
    AgGridModule
  ],
  providers: [
     { provide: DateAdapter, useClass: NgxMatMomentAdapter, deps: [MAT_DATE_LOCALE] },
    //{ provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MatPaginatorIntl, useValue: PtBrPaginatorIntl() },
    { provide: NGX_MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
    provideNgxMask(),
    CustomSnackbarComponent
  ]
})

export class SharedModule { }
